<div class="sellerBlock">
  <!-- SELLER IMAGE -->
  <vc-product-seller-badge
    class="sellerBlock__badge"
    [seller]="product.seller"
    [showTooltip]="true"
  ></vc-product-seller-badge>
  <!-- SELLER DETAILS -->
  <div class="sellerBlock__details">
    <vc-ref
      [anchor]="false"
      i18n-resource="@@PRODUCT.DETAILS.SELLER_PROFILE_SELL_LINK"
      resource="/members/profil-{{ product.seller.id }}.shtml#sell"
    >
      <div class="sellerBlock__details__ID vc-title-s">
        {{ product.seller.firstname }}
      </div>
    </vc-ref>
    <div class="sellerBlock__details__container">
      <div>
        <div *ngIf="expertSellerBadge" class="sellerBlock__details__badges">
          <vc-ref class="sellerBlock__details__badges" [anchor]="false" [resource]="path">
            <div class="vc-badge vc-badge--small vc-badge--expert">
              <vc-sprite-icons class="icon" name="badge-expert"></vc-sprite-icons>
              <span i18n="@@PRODUCT.DESCRIPTION.EXPERT_SELLER">
                Expert seller
              </span>
            </div>
          </vc-ref>
        </div>
        <div *ngIf="trustedSellerBadge" class="sellerBlock__details__badges">
          <vc-ref class="sellerBlock__details__badges" [anchor]="false" [resource]="path">
            <div class="vc-badge vc-badge--small vc-badge--trusted">
              <vc-sprite-icons class="icon" name="badge-trusted"></vc-sprite-icons>
              <span i18n="@@PRODUCT.DESCRIPTION.TRUSTED_SELLER">
                Trusted seller
              </span>
            </div>
          </vc-ref>
        </div>
        <div *ngIf="fashionActivistBadge" class="sellerBlock__details__badges">
          <vc-ref class="sellerBlock__details__badges" [anchor]="false" resource="/journal/fashion-activist-badge/">
            <div class="vc-badge vc-badge--small vc-badge--fashion-activist">
              <vc-sprite-icons class="icon" name="badge-fashion-activist"></vc-sprite-icons>
              <span i18n="@@PRODUCT.DESCRIPTION.FASHION_ACTIVIST">
                Fashion Activist
              </span>
            </div>
          </vc-ref>
        </div>
        <div *ngIf="officialStoreBadge" class="sellerBlock__details__badges">
          <div class="vc-badge vc-badge--small vc-badge--official-store">
            <span i18n="@@PRODUCT.DESCRIPTION.BRAND_STORE">
              Brand Store
            </span>
          </div>
        </div>

        <vc-ref
          *ngIf="!officialStoreBadge && product.consignment && !(product.consignment && product.seller.internalAccount)"
          class="sellerBlock__details__consignment vc-link"
          i18n-resource="@@CONSIGNMENT.SERVICE.LINK"
          [anchor]="false"
          resource="/consignment.shtml"
          (click)="trackConsignmentClick($event)"
        >
          <span i18n="@@CONSIGNMENT.SERVICE"> via our Concierge Service </span>
        </vc-ref>
      </div>

      <div class="vc-body3 sellerBlock__details__moreInfos">
        <p *ngIf="sellerPro" i18n="@@PRODUCT.DESCRIPTION.SELLER.PRO">Professional seller</p>
        <vc-ref
          *ngIf="hasProductSold()"
          [anchor]="false"
          i18n-resource="@@PRODUCT.DETAILS.SELLER_PROFILE_SELL_LINK"
          resource="/members/profil-{{ product.seller.id }}.shtml#sell"
        >
          <p>
            {{ product.seller?.statistics?.productsSold }}
            <ng-container i18n="@@PRODUCT.DESCRIPTION.ARTICLES_SOLD">items sold</ng-container>
          </p>
        </vc-ref>
      </div>
    </div>

    <vc-ref
      [anchor]="false"
      i18n-resource="@@PRODUCT.DETAILS.SELLER_PROFILE_SELL_LINK"
      resource="/members/profil-{{ product.seller.id }}.shtml#sell"
    >
      <span class="sellerBlock__details__seeProfile vc-link" i18n="@@PRODUCT.DESCRIPTION.SEE_PROFILE">
        Discover seller's vestiaire
      </span>
    </vc-ref>
  </div>
  <div class="sellerBlock__follow">
    <vc-follow-button
      [userToFollow]="product.seller.id"
      [isFollow]="isFollow"
      [isProductPage]="true"
    ></vc-follow-button>
  </div>
</div>
